import { useState } from "react"
import { z } from "zod"
import { ArrowRight, Mail } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Form } from "@/components/ui/form"
import { IconInputField } from "@/components/auth/IconInputField"
import { useAuthForm } from "@/lib/use-auth-form"
import { useSession } from "@/lib/session-context"
import { emailSchema } from "@/lib/auth-schemas"

const schema = z.object({ email: emailSchema })

export function ForgotPasswordForm() {
  const [submitted, setSubmitted] = useState(false)
  const { requestPasswordReset } = useSession()

  const { form, serverError, submit } = useAuthForm({
    schema,
    defaultValues: { email: "" },
    onSubmit: async (values) => {
      await requestPasswordReset(values)
      setSubmitted(true)
    },
  })

  return (
    <Form {...form}>
      <form onSubmit={submit} className="space-y-5" noValidate autoComplete="off">
        <IconInputField
          form={form}
          name="email"
          label="Email Address"
          icon={Mail}
          type="email"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          placeholder="operator@sentinel.os"
        />

        {serverError ? (
          <p role="alert" className="text-sm font-medium text-destructive">
            {serverError}
          </p>
        ) : null}

        {submitted ? (
          <p className="rounded-xl border border-primary/30 bg-primary/10 px-4 py-3 text-sm text-foreground">
            If that email is registered, reset instructions are on the way. Check your inbox (and spam).
          </p>
        ) : null}

        <Button
          type="submit"
          disabled={form.formState.isSubmitting || submitted}
          className="mt-4 h-12 w-full gap-2 rounded-xl text-sm font-bold shadow-md shadow-primary/20"
        >
          {submitted ? "Instructions Sent" : "Send Reset Link"}
          <ArrowRight className="h-4 w-4" />
        </Button>
      </form>
    </Form>
  )
}
